module.exports = __webpack_public_path__ + "img/map_1791549572995_91500.d433a98c.jpg";